import { auth } from '@/firebase/auth';
import { User } from 'firebase/auth';
import React from 'react';

let currentUser: User | null = null;

export type AuthStatus = 'pending' | 'logged-in' | 'logged-out'

export const useCurrentUser = () => {
  const [user, setUser] = React.useState<User | null>(currentUser);
  const [status, setStatus] = React.useState<AuthStatus>('pending');

  React.useEffect(() => {
    auth.onAuthStateChanged(async (loggedInUser) => {
      if (loggedInUser) {
        currentUser = loggedInUser;
        setStatus('logged-in');
        setUser(loggedInUser);
      } else {
        currentUser = null;
        setStatus('logged-out');
        setUser(null);
      }
    });
  });

  return [user, status] as const;
};
